import React, { useState } from "react";
import { Badge, Button, Flex, Text } from "@chakra-ui/react";
import TaskItem from "./TaskItem";
import { findCategory } from "../categories";
import { Droppable } from "react-beautiful-dnd";
import { FORUM, TRANSITION } from "../Theme/styles";

const ILE_NA_SKROCIE = 6;

const TaskContainer = (props) => {
  const [rozwinieta, setRozwinieta] = useState(false);

  const zwijana = Boolean(props.zwijana);
  const nadmiar = zwijana && !rozwinieta && props.tasks.length > ILE_NA_SKROCIE;
  const visible = nadmiar ? props.tasks.slice(0, ILE_NA_SKROCIE) : props.tasks;

  return (
    <Flex
      direction={"column"}
      gap={"2"}
      p={3}
      borderRadius={"lg"}
      flex={"1"}
      width={"100%"}
      h={"100%"}
      minH={0}
      overflowY={"auto"}
      bg={FORUM.panel}
      border="1px solid"
      borderColor={FORUM.obramowanie}
      opacity={zwijana && !rozwinieta ? 0.55 : 1}
      _hover={{ opacity: 1 }}
      transition={TRANSITION}
    >
      <Flex direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
        <Text fontSize={"lg"} fontWeight={"semibold"} color={FORUM.tekst} align={"left"}>
          {props.title}
          <Badge
            ml="2"
            bg={FORUM.plakietka}
            color={FORUM.tekst}
            borderRadius="full"
            px="2"
            fontWeight="medium"
          >
            {props.tasks.length}
          </Badge>
        </Text>
      </Flex>

      <Droppable droppableId={props.droppableId} direction="vertical">
        {(provided, snapshot) => (
          <Flex
            direction={"column"}
            gap={"2"}
            {...provided.droppableProps}
            ref={provided.innerRef}
            flex={1}
            minH={"120px"}
            borderRadius={"md"}
            transition={TRANSITION}
            bg={snapshot.isDraggingOver ? "rgba(108,153,255,0.06)" : "transparent"}
            outline={snapshot.isDraggingOver ? "1px dashed rgba(108,153,255,0.5)" : "none"}
          >
            {visible.map((task, index) => (
              <TaskItem
                key={task.id}
                id={task.id}
                taskId={task.task_id}
                ilePozycji={task.items_total}
                ileZrobionych={task.items_done}
                inneGrupy={task.other_teams}
                kind={task.kind}
                deadlinePrzydzialu={task.assignment_deadline}
                zajetePrzez={task.claimed_by}
                people={props.peoples}
                index={index}
                title={task.title}
                assignedTo={task.assigned_to}
                osoby={task.people}
                peoples={props.peoples}
                draggableId={task.id}
                piority={task.piority}
                deadline={task.deadline}
                category={props.category || task.category}
                categoryName={
                  props.pokazKategorie
                    ? findCategory(task.category)?.name || task.category
                    : null
                }
                isDragDisabled={props.isDragDisabled}
                pokazKategorie={props.pokazKategorie}
              />
            ))}
            {provided.placeholder}
          </Flex>
        )}
      </Droppable>

      {zwijana && props.tasks.length > ILE_NA_SKROCIE && (
        <Button
          size={"sm"}
          variant={"ghost"}
          onClick={() => setRozwinieta(!rozwinieta)}
          fontWeight={"normal"}
          color={FORUM.tekstPrzygaszony}
          transition={TRANSITION}
          _hover={{ color: FORUM.tekstJasny, bg: FORUM.plakietka }}
        >
          {rozwinieta
            ? "Zwiń"
            : `Pokaż wszystkie (${props.tasks.length})`}
        </Button>
      )}
    </Flex>
  );
};

export default TaskContainer;
